import axios from 'axios/dist/axios';

let code = (function () {
    return {
        getCookie: function (name) {
            let value = "; " + document.cookie;
            let parts = value.split("; " + name + "=");
            if (parts.length === 2) {
                return parts.pop().split(";").shift();
            }
        }
    }
})();

const pathLogos = '/logos/'

const defaultState = {
    selectedLanguage: "de",
    languageFromUrl: null,
    languageList: [],
    texts: [],
    isAppDataLoaded: false,
    sslsubjectdnHeader: null,
    selfRegistrationEnabled: false,
    mustShowEvaluationPage: code.getCookie('evaluation'),
    pfiEnableEdit: false,
    showUserComment: false,
    voucherData: null,
    voucherCallbackData: null,
    mustShowBrowsersListPopup: false,
    appProperties: {
        // APPLICATION_TYPE: "", // null
        GUI_THEME_COLOR: "#a43a45", // null
        GUI_THEME_FONT: "Roboto, sans-serif",
        GUI_THEME_LOGO: "logo-i4m.svg",
        GUI_THEME_LOGO_HC: "logo-i4m_HC.svg",
        GUI_THEME_LOGO_DARK: "logo-i4m_Dark.svg",
        GUI_THEME_LOGO_DARK_HC: "logo-i4m_Dark_HC.svg",
    },
    showUserCommentShortcut: false,
    showUserCommentNoShortcut: false,
    priorityListVal: true,
    evaluationScreenVal: true,
    verifiedBrowsers: {},
    logoFile: null

};


// ======================================================================
// Initial State
// ======================================================================

const state = {
    selectedLanguage:           defaultState.selectedLanguage,
    languageList:               defaultState.languageList,
    texts:                      defaultState.texts,
    languageFromUrl:            defaultState.languageFromUrl,
    isAppDataLoaded:            defaultState.isAppDataLoaded,
    sslsubjectdnHeader:         defaultState.sslsubjectdnHeader,
    appTypeName:                defaultState.appTypeName, // @TODO Hopefully, this will be removed in the future. We should store this value only in "appProperties" object (on "APPLICATION_TYPE" key) and use it from there by calling getAppPropertyValue("APPLICATION_TYPE") getter function.
    selfRegistrationEnabled:    defaultState.selfRegistrationEnabled,
    mustShowEvaluationPage:     defaultState.mustShowEvaluationPage,
    pfiEnableEdit:              defaultState.pfiEnableEdit,
    showUserComment:            defaultState.showUserComment,
    voucherData:                defaultState.voucherData,
    voucherCallbackData:        defaultState.voucherCallbackData, // Data to be passed when doing a POST request to voucher's callbackUrl (for example when the user clicks "Continue" button in Chatbot, in a context when the voucher is present and the voucher has a "callbackUrl").
    mustShowBrowsersListPopup:  defaultState.mustShowBrowsersListPopup,
    appProperties:              defaultState.appProperties,
    showUserCommentShortcut:    defaultState.showUserCommentShortcut,
    showUserCommentNoShortcut:  defaultState.showUserCommentNoShortcut,
    priorityListVal:            defaultState.priorityListVal,
    evaluationScreenVal:        defaultState.evaluationScreenVal,
    verifiedBrowsers:           defaultState.verifiedBrowsers,
    logoFile:                   defaultState.logoFile
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getSelectedLang:            state => state.selectedLanguage,
    getTexts:                   state => state.texts,
    getLanguageList:            state => state.languageList,
    getLoadApp:                 state => state.isAppDataLoaded, // @TODO This is kept here just for backward compatibility. We have to check the code and replace it everywhere with "getIsAppDataLoaded".
    getIsAppDataLoaded:         state => state.isAppDataLoaded,
    getSslsubjectdnHeader:      state => state.sslsubjectdnHeader,
    getSelfRegistrationEnabled: state => state.selfRegistrationEnabled,
    getMustShowEvaluationPage:  (state, getters) => {
        if (getters.getAppPropertyStudyAccess) {
            return false;
        }
        return state.mustShowEvaluationPage
    },
    getPfiEnableEdit:           state => state.pfiEnableEdit,
    getShowUserComment:         state => state.showUserComment,
    getVoucherData:             state => state.voucherData,
    getVoucherCallbackData:     state => state.voucherCallbackData,
    getMustShowBrowsersListPopup: state => state.mustShowBrowsersListPopup,


    getAppProperties:           state => state.appProperties, // This returns the whole appProperties object, but probably you won't need it. If you need only a single property from that object, please use getAppPropertyValue function and pass the property name as param. Ex: getAppPropertyValue('GUI_THEME_COLOR')
    getAppTypeName:             state => state.appProperties.APPLICATION_TYPE || null, // @TODO Hopefully, this will be deprecated. Instead of using "getAppTypeName" getter we should call getAppPropertyValue("APPLICATION_TYPE") getter function.
    getAppPropertyValue: (state) => {

        // Unlike other getters that usually are used as variables/object properties, this getter returns a function
        // and should be called like functions, for example getAppPropertyValue("APPLICATION_TYPE").
        // We MUST pass the property name (key) as parameter to the function.
        // If the given key is not found in the app properties object received from the API, it looks for it
        // in the default app properties object and returns the default value from there, if it's found. If the key is
        // is missing from there too, the function returns NULL.
        // IMPORTANT: We should always use this function when we need a specific app property's value
        //            A special case is "GUI_THEME_LOGO" key. We can call getAppPropertyValue("GUI_THEME_LOGO")
        //            and it will return the filename of the logo image. But if we need the logo file itself so we can
        //            display it, we have to use "getLogo" getter instead.

        return (appPropertyName) => {

            if (typeof appPropertyName !== 'string') {
                // If no property key is received as param, the function returns NULL.
                return null;
            }


            let appPropValue = null;

            if (state.appProperties !== null && typeof state.appProperties[appPropertyName] !== "undefined") {
                appPropValue = state.appProperties[appPropertyName];
            }
            else if (typeof defaultState.appProperties[appPropertyName] !== "undefined") {
                appPropValue = defaultState.appProperties[appPropertyName];
            }

            return appPropValue;
        }
    },
    getAppPropertyValueArray: (state, getters) => {

        /**
         * Gets a property from appProperties, splits its string value by a separator and returns the resulted array.
         * @param {String} appPropertyName - App property key. (Ex. "SHARING_CHANNELS").
         * @param {Object} options (optional. Default: {separator: ",", mustTrimAll: true, mustUppercaseAll: false}).
         *                      - `separator`: the string will be split when this (these) character(s) is (are) found.
         *                      - `mustTrimAll`: if true, removes any beginning and ending spaces from each item in the returned array.
         *                      - `mustUppercaseAll`: if true, makes sure that each item in the returned array is uppercase.
         *
         * @example For the following application property: { "SHARING_CHANNELS": "pdf, email, translate" }
         * @example     - `getAppPropertyValueArray("SHARING_CHANNELS")` returns: ["pdf", "email", "translate"].
         * @example     - `getAppPropertyValueArray("SHARING_CHANNELS", {mustUppercaseAll: true})` returns: ["PDF", "EMAIL", "TRANSLATE"].
         * @example     - `getAppPropertyValueArray("SHARING_CHANNELS", {mustTrimAll: false})` returns: ["pdf", " email", " translate"] (see the spaces).
         * @example     - `getAppPropertyValueArray("SHARING_CHANNELS", {separator: " ", mustTrimAll: false})` returns: ["pdf,", "email,", "translate"] (see the spaces).
         */
        return (appPropertyName, options) => {

            let defaultOptions = {
                separator: ",",
                mustTrimAll: true,
                mustUppercaseAll: false
            };

            if (typeof options === "undefined") {
                options = defaultOptions;
            }
            else {
                if (typeof options.separator !== "string" || options.separator.length === 0) {
                    options.separator = defaultOptions.separator;
                }
                if (typeof options.mustTrimAll !== "boolean") {
                    options.mustTrimAll = defaultOptions.mustTrimAll;
                }
                if (typeof options.mustUppercaseAll !== "boolean") {
                    options.mustUppercaseAll = defaultOptions.mustUppercaseAll;
                }
            }

            let appPropRawValue = getters.getAppPropertyValue(appPropertyName);

            let appPropValueArr = [];
            if (typeof appPropRawValue === "string" && appPropRawValue.length > 0) {
                appPropValueArr = appPropRawValue.split(options.separator);
            }

            if (options.mustTrimAll === true) {
                appPropValueArr.forEach((item, index) => {
                    appPropValueArr[index] = item.trim();
                });
            }

            if (options.mustUppercaseAll === true) {
                appPropValueArr.forEach((item, index) => {
                    appPropValueArr[index] = item.toUpperCase();
                });
            }

            return appPropValueArr;
        }
    },
    getAppPropertyStudyAccess: (state, getters) => {
        if (typeof getters.getAppPropertyValue('STUDY_ACCESS') === 'string') {
            return getters.getAppPropertyValue('STUDY_ACCESS').toLowerCase() === 'true';
        }
        return false;
    },
    /**
     * Returns logo file that can be displayed in the page. If you only need the filename of the logo, you have to call getAppPropertyValue("GUI_THEME_LOGO").
     * @param state
     * @param getters
     * @param rootState
     * @param rootGetters
     */
    getLogo: (state, getters, rootState, rootGetters) => {

        let logoFilenameSourceProperty;
        if (rootGetters["ThemeStore/getIsDarkTheme"]) {
            logoFilenameSourceProperty = rootGetters["ThemeStore/getIsHighContrast"] ? 'GUI_THEME_LOGO_DARK_HC' : 'GUI_THEME_LOGO_DARK';
        }
        else {
            logoFilenameSourceProperty = rootGetters["ThemeStore/getIsHighContrast"] ? 'GUI_THEME_LOGO_HC' : 'GUI_THEME_LOGO';
        }

        const fileRootPath = getters.getAppPropertyValue('FILE_ROOT_PATH');

        // If we have the appProperties set and the logo filename is set in the appProperties, we try to load the logo file.
        if (state.appProperties && typeof state.appProperties[logoFilenameSourceProperty] !== "undefined" && fileRootPath != null && fileRootPath !== 'null') {
            let image = new Image();
            image.src = fileRootPath + pathLogos + state.appProperties[logoFilenameSourceProperty];
            image.onload = function () {
                state.logoFile = fileRootPath + pathLogos + state.appProperties[logoFilenameSourceProperty];
            }
            image.onerror = function () {
                console.log('Setting the default logo');
                // The logo is not set on the server
                try {
                    // Try to use the default theme's logo.
                    state.logoFile = require('../../../../static/img/logo/' + defaultState.appProperties[logoFilenameSourceProperty]);
                }
                catch (e) {
                    console.log('No logo was found');
                    state.logoFile = null;
                    // If the default light theme's logo is not available in logo folder, we can't do anything else, that's it, we won't show any logo. :(
                }
            }
            // let logoRequest = axios.get(fileRootPath + pathLogos + state.appProperties[logoFilenameSourceProperty]);
            //
            // logoRequest.then((response) => {
            //     // The logo is set on the server
            //     state.logoFile = fileRootPath + pathLogos + state.appProperties[logoFilenameSourceProperty];
            // }).catch((error) => {
            //     console.log('Setting the default logo');
            //     // The logo is not set on the server
            //     try {
            //         // Try to use the default theme's logo.
            //         state.logoFile = require('../../../../static/img/logo/' + defaultState.appProperties[logoFilenameSourceProperty]);
            //     }
            //     catch (e) {
            //         console.log('No logo was found');
            //         state.logoFile = null;
            //         // If the default light theme's logo is not available in logo folder, we can't do anything else, that's it, we won't show any logo. :(
            //     }
            // })

        }
        // If the logo is still not set (we couldn't find the default theme logo), just use the default logo of the light theme.
        else {
            try {
                // Try to use the default theme's logo.
                state.logoFile = require('../../../../static/img/logo/' + defaultState.appProperties[logoFilenameSourceProperty]);
            }
            catch (e) {
                state.logoFile = null;
                // If the default light theme's logo is not available in logo folder, we can't do anything else, that's it, we won't show any logo. :(
            }
        }

        return state.logoFile;
    },
    getShowUserCommentShortcut: state => state.showUserCommentShortcut,
    getShowUserCommentNoShortcut: state => state.showUserCommentNoShortcut,
    getPriorityListVal: state => state.priorityListVal,
    getEvaluationScreenVal: state => state.evaluationScreenVal,
    getVerifiedBrowsers: state => state.verifiedBrowsers,

    getDocCodeList: (state) => {

        // This function returns a code list for the appProperties values of DOC_ADDRESS that are
        // present on the appProperties object
        // the function takes the parameter that specifies the application type
        return (appType) => {
            let docCodeList = [];

            const docAddressRegex = new RegExp("DOC_"+ appType +"_ADDRESS_[1-9]");
            const onlyNumbersRegex = /[1-9]/g;


            // We get the properties that match DOC_PFI_ADDRESS_
            const properties = Object.keys(state.appProperties).filter(property => {
                return property.match(docAddressRegex);
            });


            // For each found property extract the code
            properties.forEach(property => {
                docCodeList.push(property.match(onlyNumbersRegex)[0]);
            })


            return docCodeList.sort();
        }
    },

    getDocApplicationType: () => {
        return () => {
            let smassHomeRoute = sessionStorage.getItem("smass-home-route");

            if (smassHomeRoute !== null && smassHomeRoute === "PF_ChatBotPage") {
                return "PFI";
            }

            return "PRO";
        }
    }
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadTranslationData ({ dispatch, commit, rootGetters, getters, rootState } ) {


        commit('setLanguageFromUrl');

        const currentUrl = window.location.hash;

        let result = /(\/)([a-zA-Z\-\_]*)/.exec(currentUrl);
        const currentPage = result[2];


        let code = (function () {
            return {
                getCookie: function (name) {
                    let value = "; " + document.cookie;
                    let parts = value.split("; " + name + "=");
                    if (parts.length == 2) {
                        return parts.pop().split(";").shift();
                    }
                }
            }
        })();

        let requestParams = '';

        let browserLanguage = navigator.language.substring(0,2);


        if (typeof state.languageFromUrl !== "undefined" && state.languageFromUrl !== null && state.languageFromUrl.length === 2){
            requestParams = {
                "value" : state.languageFromUrl,
                "currentPage" : currentPage
            }
        } else if (code.getCookie('language')) {
            requestParams = {
                //"value" : state.languageFromUrl
                "value" : code.getCookie('language'),
                "currentPage" : currentPage
            }
        } else {
            requestParams = {
                "value" : browserLanguage,
                "currentPage": currentPage
            }
        }

        commit("setSelectedLanguage", requestParams.value); // Needed to set here the selected language to the store for the cases when state.selectedLanguage has to be used before finishing the request to /applicationData.

        let promise = new Promise((resolve, reject) => {


            //@TODO Here in TranslationStore we request applicationData (translation data, user data etc.) from server, not only translation data. Maybe we should rename the store or something...

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/applicationData', requestParams);

            axiosRequest.then((response) => {
                commit('setVoucherData', response.data.voucherData);
                commit('setLanguageList', response.data.languages);
                commit('setSelectedLanguage', response.data.selectedLanguage);
                commit('setTexts', response.data.texts);

                // Update "language" cookie too.
                this._vm.$UtilitiesPlugin.setCookie('language', response.data.selectedLanguage, 366);

                commit('setAppTypeName', response.data.appProperties.APPLICATION_TYPE);
                commit('setSelfRegistrationEnabled', String(response.data.appProperties.USER_SELF_REGISTRATION_ENABLED).toLowerCase() === "true");
                commit('setVerifiedBrowsers', response.data.verifiedBrowsers);

                commit("setAppProperties", response.data.appProperties);

                // We send the color values to the ThemeStore
                dispatch("ThemeStore/setGuiThemeColors", {
                   "GUI_THEME_WARNING_COLOR" : response.data.appProperties['GUI_THEME_WARNING_COLOR'],
                   "GUI_THEME_WARNING_COLOR_DARK":  response.data.appProperties['GUI_THEME_WARNING_COLOR_DARK'],
                   "GUI_THEME_COLOR": response.data.appProperties['GUI_THEME_COLOR'],
                   "GUI_THEME_COLOR_DARK": response.data.appProperties['GUI_THEME_COLOR_DARK']
                }, { root: true });


                if (typeof response.data.userData !== "undefined") {
                    commit("UserStore/setUserData", response.data.userData, { root: true });
                }

                dispatch("SymptomsQuestionsStore/updateAssessmentTypeByAppProp", null, {root: true});

                //if there is a value for sslsubjectdnHeader, then the user is already logged in and will be forwarded to the home page automatically
                commit('setSslsubjectdnHeader', response.data.sslsubjectdnHeader); // @TODO Not sure if we need this anymore.

                commit('setPfiEnableEdit', response.data.pfiEnableEdit);

                if (typeof response.data.appProperties !== "undefined" && typeof response.data.appProperties.APPLICATION_TYPE !== "undefined") {
                    commit("UserStore/setCurrentAppType", response.data.appProperties.APPLICATION_TYPE, {root: true});
                }

                commit('setIsAppDataLoaded', true);

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;
    },

    submitLanguageChange(context, newLangKey) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/changeLanguage', {
                value: newLangKey
            });
            axiosRequest.then((response) => {
                if(typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) { // returnCode=0 means success.

                    // Set cookie for language.
                    this._vm.$UtilitiesPlugin.setCookie('language', newLangKey, 366);

                    resolve(response);
                }
                else {
                    reject("Failed to change the language.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;
    },

    appendProductRelatedTranslationData ({ commit }, textsDataObj) {
        commit("appendTextsToLanguage", textsDataObj);
    },

    submitEvaluationPageType({commit}, newEvaluationPageType) {
        let promise = new Promise((resolve, reject) => {

                /* SET COOKIE FOR EVALUATION PAGE STATUS */
                function setCookie(name, value, days) {
                    let expires = "";
                    if (days) {
                        let date = new Date();
                        date.setTime(date.getTime() + (days*24*60*60*1000));
                        expires = "; expires=" + date.toUTCString();
                    }
                    document.cookie = name + "=" + (value || "")  + expires +"; path=/";
                }

                if(newEvaluationPageType === true){

                    setCookie('evaluation', true, 366);
                    commit('setMustShowEvaluationPage', true);

                } else if(newEvaluationPageType === false) {

                    setCookie('evaluation', false, 366);
                    commit('setMustShowEvaluationPage', false)

                }

        });

        return promise;
    },

    showBrowsersListPopup({commit}) {
        let promise = new Promise( (resolve, reject) => {
            commit('setMustShowBrowsersListPopup', true)
        })
         return promise;
    },

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setLanguageList (state, value) {
        state.languageList = value;
    },
    setSelectedLanguage (state, value) {
        document.documentElement.lang = value;
        state.selectedLanguage = value;
    },
    setTexts (state, value) {
        state.texts = value;
    },
    setSslsubjectdnHeader (state, value){
        state.sslsubjectdnHeader = value;
    },

    setPfiEnableEdit (state, value){
        state.pfiEnableEdit = value;
    },


    /**
     * @param state
     * @param {Object} textsToAppend - Object containing the list of texts to append. Each property/value is a text (property = translation key, value = translated text)
     */
    appendTextsToLanguage(state, textsToAppend) {
        state.texts = {...state.texts, ...textsToAppend};
    },

    setLanguageFromUrl(state) {

        let uriSegments = window.location.href.split('?');

        // Look for "lang" or "language" query url param.
	    let langUrlParamValue;
	    if (uriSegments && uriSegments.length == 2){
            let params = uriSegments[1].split('&');

            for (let i=0; i<params.length; i++) {
                let param = params[i].split('=');
                let paramKey = param[0];
                let paramValue = param[1];

                if (paramKey === "lang" || paramKey === "language"){
                    langUrlParamValue = paramValue;
                    break; // We found what we were looking for, so stop the loop.
                }
            }
	    }

        if (typeof langUrlParamValue !== 'undefined'){

            if (langUrlParamValue.length > 2) {
                langUrlParamValue = langUrlParamValue.substring(0, 2); // We always use the two characters length language code.  If it's longer, only use the first two chars.
            }

            state.languageFromUrl = langUrlParamValue;

            // Set the "language" cookie too, it's needed for page refresh after a route change (when the "?lang=..." or "?language=..." url query param might be lost).
            this._vm.$UtilitiesPlugin.setCookie('language', langUrlParamValue, 366);

            // Remove "lang" and "language" params from the url.
            let newUrl = window.location.href;
            newUrl = newUrl.replace("language=" + langUrlParamValue, "");
            newUrl = newUrl.replace("lang=" + langUrlParamValue, "");
            newUrl = newUrl.replace("/?#/", "/#/");
            window.location.replace(newUrl);
        }
    },

    setIsAppDataLoaded (state, value) {
        state.isAppDataLoaded = value;
    },

    setAppTypeName (state, value) {
        state.appTypeName = value; // @TODO state.appTypeName will be deprecated and this row will be removed from here. We will use only "state.appProperties.APPLICATION_TYPE" instead.

        if (typeof state.appProperties !== "object") {
            state.appProperties = {};
        }
        state.appProperties.APPLICATION_TYPE = value;
    },
    setSelfRegistrationEnabled(state, value) {
        state.selfRegistrationEnabled = value;
    },
    setMustShowEvaluationPage(state, value) {
        state.mustShowEvaluationPage = value;
    },
    setShowUserComment(state, value) {
        state.showUserComment = value;
    },
    setVoucherData(state, newValue) {
        state.voucherData = newValue;
    },
    setVoucherCallbackData(state, data) {
        state.voucherCallbackData = data;
    },
    setMustShowBrowsersListPopup(state, newValue) {
        state.mustShowBrowsersListPopup = newValue;
    },

    setAppProperties(state, newData) {
        this._vm.$set(state, 'appProperties', newData);
    },

    setShowUserCommentShortcut(state, newValue) {
        state.showUserCommentShortcut = newValue;
    },
    setShowUserCommentNoShortcut(state, newValue) {
        state.showUserCommentNoShortcut = newValue;
    },
    setPriorityListVal(state, newVal) {
        state.priorityListVal = newVal;
    },
    setEvaluationScreenVal(state, newVal) {
       state.evaluationScreenVal = newVal;
    },
    setVerifiedBrowsers(state, newVal) {
        state.verifiedBrowsers = newVal;
    },
    setLogoFile(state, newVal) {
        state.logoFile = newVal;
    },

    // ----------------------------------------------------------

    resetStore (state) {
        state.selectedLanguage          = defaultState.selectedLanguage;
        state.languageFromUrl           = defaultState.languageFromUrl;
        state.languageList              = defaultState.languageList;
        state.texts                     = defaultState.texts;
        state.isAppDataLoaded           = defaultState.isAppDataLoaded;
        state.selfRegistrationEnabled   = defaultState.selfRegistrationEnabled;
        state.mustShowEvaluationPage    = defaultState.mustShowEvaluationPage;
        state.showUserComment           = defaultState.showUserComment;
        state.voucherData               = defaultState.voucherData;
        state.mustShowBrowsersListPopup = defaultState.mustShowBrowsersListPopup;
        state.appProperties             = defaultState.appProperties;
        state.showUserCommentShortcut   = defaultState.showUserCommentShortcut;
        state.showUserCommentNoShortcut = defaultState.showUserCommentNoShortcut;
        state.priorityListVal           = defaultState.priorityListVal;
        state.evaluationScreenVal       = defaultState.evaluationScreenVal;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/TranslationStore.js